import {
    REQUEST_CLOSE_SUBMISSION_CRM_ACTION_BEGIN,
    REQUEST_CLOSE_SUBMISSION_CRM_ACTION_SUCCESS,
    REQUEST_CLOSE_SUBMISSION_CRM_ACTION_FAILURE
} from '../../../Actions/FormServiceActions/CancellationReason/RequestCloseSubmissionCrmAction';

const initialState = {
    data: null,
    errors: null,
    wasSuccessful: false,
    loading: false
};

export default function requestCloseSubmissionCrmAction(state = initialState, action) {
    switch (action.type) {
        case REQUEST_CLOSE_SUBMISSION_CRM_ACTION_BEGIN:
            return {
                ...state,
                loading: true
            };

        case REQUEST_CLOSE_SUBMISSION_CRM_ACTION_SUCCESS:
            return {
                ...state,
                data: action.payload,
                wasSuccessful: true,
                errors: null,
                loading: false
            };

        case REQUEST_CLOSE_SUBMISSION_CRM_ACTION_FAILURE:
            return {
                ...state,
                errors: action.payload,
                loading: false
            };

        default:
            return state;
    }
}